import React, { useEffect, useState } from "react";
import backgroundWide from "../../background-wide.jpeg";
import background from "../../background.jpeg";

import image1 from "../../photo.png";
import gif1 from "../../media1.gif";
import gif2 from "../../media2.gif";
import gif3 from "../../media3.gif";
import gif4 from "../../media4.gif";
import gif5 from "../../media5.gif";
import gif6 from "../../media6.gif";

import "./StarwardsPage.css";

function isLandscape() {
  return window.innerWidth > window.innerHeight;
}

const ToTheStarsPage = () => {
  const [imageUrl, setImageUrl] = useState(
    isLandscape() ? backgroundWide : background
  );
  useEffect(() => {
    window.addEventListener("resize", () =>
      setImageUrl(isLandscape() ? backgroundWide : background)
    );
  }, []);

  return (
    <>
      <div className="div-container">
        <div className="div-1 full-img">
          <img src={"dist" + imageUrl} className="fit content" />
          <button
            style={{ marginBottom: 20 }}
            className="btn btn-orange btn-lg btn-btm-ctr"
            onClick={() =>
              (window.location.href = `mailto:media@pixelinium.com?subject=Notify Me!&body=Hi Pixelinium!%0d%0a%0d%0aPlease notify me on this email when more information about your game becomes available.%0d%0a%0d%0aThanks!%0d%0a{NAME HERE}`)
            }
          >
            Keep Me Informed!
          </button>
        </div>

        <div className="div-2 split-text split-img">
          <div className="div-text-left div-text-width">
            <h1>
              <strong>Starwards</strong>
            </h1>
            <p>
              Starwards is an upcoming physics action adventure puzzler that is
              out of this world. The game follows the adventures of Lupin the
              fox as he embarks on a journey in search of his mentor who got
              lost among the stars. In his travels, Lupin meets a myriad of
              quirky characters, who offer clues to the whereabouts of his
              mentor.
            </p>
          </div>
          <div className="div-img-right">
            <img src={"dist" + image1} className="fit content" />
          </div>
          <div className="scrollmenu">
            <img src={"dist" + gif1} className="img_wrapper" />
            <img src={"dist" + gif2} className="img_wrapper" />
            <img src={"dist" + gif3} className="img_wrapper" />
            <img src={"dist" + gif4} className="img_wrapper" />
            <img src={"dist" + gif5} className="img_wrapper" />
            <img src={"dist" + gif6} className="img_wrapper" />
          </div>
        </div>

        <div className="div-3 split-text split-img">
          <div className="div-text-width">
            <p>
              Starwards marries the realms of physics puzzlers and action/arcade
              side scrollers, offering challenges to test your wits and your
              reflexes. The gameplay is easy to learn, tough to master, and
              offers surprising depth thanks to its environments.
            </p>
          </div>
          <div className="div-video">
            <div className="video_wrapper">
              <iframe
                frameBorder="0"
                src="https://www.youtube.com/embed/XhwMkDJmP6M?modestbranding=1&amp;playsinline=0&amp;rel=0"
                allow="autoplay"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
      <div className="div-2"></div>
    </>
  );
};

export default ToTheStarsPage;
